import { apiRequest, withToken } from './http-client';

export const globalSearch = async (token, { q = '', type = 'all', limit = 10 } = {}) => {
    const params = {
        q: String(q || '').trim(),
        limit,
    };

    if (type && type !== 'all') {
        params.type = type;
    }

    return apiRequest({
        method: 'get',
        url: '/search',
        headers: withToken(token),
        params,
    }, 'No se pudo validar la sesión');
};
